// extracted by mini-css-extract-plugin
export default {"container":"templateSent_container__6lA58","templateBox":"templateSent_templateBox__NZVJ4","imageBox":"templateSent_imageBox__+k+sb"};